/** Mirrors API catalog for offline/header rendering before /avatars loads. */
export const ANIMAL_AVATARS = [
  { id: "dog", emoji: "🐶" },
  { id: "cat", emoji: "🐱" },
  { id: "fox", emoji: "🦊" },
  { id: "owl", emoji: "🦉" },
  { id: "bear", emoji: "🐻" },
  { id: "rabbit", emoji: "🐰" },
  { id: "panda", emoji: "🐼" },
  { id: "lion", emoji: "🦁" },
  { id: "tiger", emoji: "🐯" },
  { id: "wolf", emoji: "🐺" },
  { id: "deer", emoji: "🦌" },
  { id: "hedgehog", emoji: "🦔" },
  { id: "koala", emoji: "🐨" },
  { id: "penguin", emoji: "🐧" },
  { id: "otter", emoji: "🦦" },
  { id: "squirrel", emoji: "🐿️" },
  { id: "eagle", emoji: "🦅" },
  { id: "dolphin", emoji: "🐬" },
  { id: "horse", emoji: "🐴" },
  { id: "frog", emoji: "🐸" },
];

export const getAnimalEmoji = (id) =>
  ANIMAL_AVATARS.find((animal) => animal.id === id)?.emoji || null;
